import Subscription from '@/components/routes/subscription/Subscription'

const subscriptionRoutes = [
  {
    name: 'subscription',
    path: '/subscription',
    component: Subscription
  }
]

export default subscriptionRoutes
